<template>
  <g>
    <g transform="scale(0.55)">
        <text transform="matrix(1 0 0 1 75 50)" class="name"
            >조이스틱{{ number }}</text
        >
        <path
            class="st0"
            d="M70.27,270V63h293.46v44h35.77c4.14,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5h-35.77v11h35.77
        c4.14,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5h-35.77v12h35.77c4.14,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5h-35.77v11h35.77
        c4.14,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5h-35.77v12h35.77c4.14,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5h-35.77v42H70.27z
        M342.5,242c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5c4.14,0,7.5-3.36,7.5-7.5S346.64,242,342.5,242z M90.5,242
        c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5c4.14,0,7.5-3.36,7.5-7.5S94.64,242,90.5,242z M342.5,76c-4.14,0-7.5,3.36-7.5,7.5
        s3.36,7.5,7.5,7.5c4.14,0,7.5-3.36,7.5-7.5S346.64,76,342.5,76z M90.5,76c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5
        c4.14,0,7.5-3.36,7.5-7.5S94.64,76,90.5,76z"
        />
        <g>
              <path
                  class="st1"
                  d="M73.27,66v201h287.46V66H73.27z M90.5,260c-5.8,0-10.5-4.7-10.5-10.5c0-5.8,4.7-10.5,10.5-10.5
              s10.5,4.7,10.5,10.5C101,255.3,96.3,260,90.5,260z M90.5,94C84.7,94,80,89.3,80,83.5C80,77.7,84.7,73,90.5,73S101,77.7,101,83.5
              C101,89.3,96.3,94,90.5,94z M342.5,260c-5.8,0-10.5-4.7-10.5-10.5c0-5.8,4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5
              C353,255.3,348.3,260,342.5,260z M342.5,94c-5.8,0-10.5-4.7-10.5-10.5c0-5.8,4.7-10.5,10.5-10.5S353,77.7,353,83.5
              C353,89.3,348.3,94,342.5,94z"
              />
            <g style="transform:translate(-13px, 8px)">
                <text
                    transform="matrix(1 0 0 1 288.4111 100.5205)"
                    class="st2 st3 st4"
                    >GND</text
                >
                <text
                    transform="matrix(1 0 0 1 292.2324 130.5205)"
                    class="st2 st3 st4"
                    >VCC</text
                >
                <text
                    transform="matrix(1 0 0 1 307.9961 165.5205)"
                    class="st2 st3 st4"
                    >X</text
                >
                <text
                    transform="matrix(1 0 0 1 308.416 195.5205)"
                    class="st2 st3 st4"
                    >Y</text
                >
                <text
                    transform="matrix(1 0 0 1 293.8984 226.5205)"
                    class="st2 st3 st4"
                    >KEY</text
                >
            </g>
        </g>
        <!-- key button -->
        <g style="transform: translate(13px,-60px)">
          <rect
            x="240"
            y="215"
            width="30"
            height="30"
            style="fill:#eee; stroke: #777;"
          />
          <circle
            :class="{'st9':!push, 'on':push && on}"
            cx="255"
            cy="230"
            r="10"
            class="btn-key"
            @click="pushKeyButton"
          />
        </g>
        <radialGradient
            id="SVGID_1_"
            cx="174.5"
            cy="167.5"
            r="80.5"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" style="stop-color:#999999" />
            <stop offset="0.2395" style="stop-color:#969696" />
            <stop offset="0.4005" style="stop-color:#8D8D8D" />
            <stop offset="0.5385" style="stop-color:#7E7E7E" />
            <stop offset="0.6636" style="stop-color:#696969" />
            <stop offset="0.7798" style="stop-color:#4D4D4D" />
            <stop offset="0.8896" style="stop-color:#2B2B2B" />
            <stop offset="0.9925" style="stop-color:#030303" />
            <stop offset="1" style="stop-color:#000000" />
        </radialGradient>
        <circle id="outer-jyst" class="st5" cx="174.5" cy="167.5" r="80.5" />
        <radialGradient
            id="SVGID_2_"
            cx="174.5"
            cy="167.5"
            r="52.5"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" style="stop-color:#999999" />
            <stop offset="0.164" style="stop-color:#959595" />
            <stop offset="0.3258" style="stop-color:#898989" />
            <stop offset="0.4868" style="stop-color:#757575" />
            <stop offset="0.6474" style="stop-color:#5A5A5A" />
            <stop offset="0.8076" style="stop-color:#363636" />
            <stop offset="0.9655" style="stop-color:#0A0A0A" />
            <stop offset="1" style="stop-color:#000000" />
        </radialGradient>
        <circle
            @click="setControll"
            id="inner-jyst"
            class="st6"
            cx="174.5"
            cy="167.5"
            r="52.5"
        />
        <!-- pins -->
        <g style="transform: translate(0px, 8px)">
            <g class="pin" style="transform: translate(0, -21px)">
                <rect
                    x="325.97"
                    y="99.26"
                    transform="matrix(6.123234e-17 -1 1 6.123234e-17 222.9828 450.9665)"
                    class="st7"
                    width="22"
                    height="29.46"
                />
                <path
                    class="st8"
                    d="M399.5,119H352v-9h47.5c2.49,0,4.5,2.01,4.5,4.5v0C404,116.99,401.99,119,399.5,119z"
                />
                <rect
                    :id="`${pincode}MS`"
                    @click="onClick(`${pincode}MS`)"
                    class="pin-cover terminal snap"
                    x="390"
                    y="105"
                    width="20"
                    height="20"
                />
            </g>
            <g class="pin" style="transform: translate(0, -15px)">
                <rect
                    x="325.97"
                    y="125.76"
                    transform="matrix(6.123234e-17 -1 1 6.123234e-17 196.4828 477.4665)"
                    class="st7"
                    width="22"
                    height="29.46"
                />
                <path
                    class="st8"
                    d="M399.5,145H352v-9h47.5c2.49,0,4.5,2.01,4.5,4.5l0,0C404,142.99,401.99,145,399.5,145z"
                />
                <rect
                    :id="`${pincode}PS`"
                    @click="onClick(`${pincode}PS`)"
                    class="pin-cover terminal snap"
                    x="390"
                    y="132"
                    width="20"
                    height="20"
                />
            </g>
            <g class="pin" style="transform: translate(0, -9px)">
                <rect
                    x="325.97"
                    y="152.26"
                    transform="matrix(6.123234e-17 -1 1 6.123234e-17 169.9828 503.9665)"
                    class="st7"
                    width="22"
                    height="29.46"
                />
                <path
                    class="st8"
                    d="M399.5,172H352v-9h47.5c2.49,0,4.5,2.01,4.5,4.5l0,0C404,169.99,401.99,172,399.5,172z"
                />
                <rect
                    :id="`${pincode}XT`"
                    @click="onClick(`${pincode}XT`)"
                    class="pin-cover terminal snap"
                    x="390"
                    y="160"
                    width="20"
                    height="20"
                />
            </g>
            <g class="pin" style="transform: translate(0, -3px)">
                <rect
                    x="325.97"
                    y="178.76"
                    transform="matrix(6.123234e-17 -1 1 6.123234e-17 143.4828 530.4665)"
                    class="st7"
                    width="22"
                    height="29.46"
                />
                <path
                    class="st8"
                    d="M399.5,198H352v-9h47.5c2.49,0,4.5,2.01,4.5,4.5l0,0C404,195.99,401.99,198,399.5,198z"
                />
                <rect
                    :id="`${pincode}YT`"
                    @click="onClick(`${pincode}YT`)"
                    class="pin-cover terminal snap"
                    x="390"
                    y="185"
                    width="20"
                    height="20"
                />
            </g>
            <g class="pin" style="transform: translate(0, 3px)">
                <rect
                    x="325.97"
                    y="205.26"
                    transform="matrix(6.123234e-17 -1 1 6.123234e-17 116.9828 556.9665)"
                    class="st7"
                    width="22"
                    height="29.46"
                />
                <path
                    class="st8"
                    d="M399.5,225H352v-9h47.5c2.49,0,4.5,2.01,4.5,4.5l0,0C404,222.99,401.99,225,399.5,225z"
                />
                <rect
                    :id="`${pincode}BT`"
                    @click="onClick(`${pincode}BT`)"
                    class="pin-cover terminal snap"
                    x="390"
                    y="210"
                    width="20"
                    height="20"
                />
            </g>
        </g>
    </g>
  </g>
</template>

<script>
/* eslint-disable */
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

const map = function (val, a, b, c, d) {
  return ((val - a) / (b - a)) * (d - c) + c
}
export default {
  props: ['data'],
  mixins: [pins],
  name: 'Joystick',
  data () {
    return {
      on: false,
      push: false,
      socket: null,
      xsocket: null,
      ysocket: null
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    start (socket) {
      this.socket = socket
      this.on = true
      this.createXYSocket()
      this.initDraggable()
    },
    off () {
      this.on = false
      this.socket = null
    },
    pushKeyButton (e) {
      if (this.on) {
        e.stopPropagation()
        this.push = !this.push
        const value = this.push ? 1 : 0
        this.$store.commit('socket/sendMessage', { socket: this.socket, message: { value } })
      }
    },
    createXYSocket () {
      const url = this.$store.state.socket.socket.url
      this.xsocket = new WebSocket(url + `/input/Joystick_X_${this.number}/`)
      this.ysocket = new WebSocket(url + `/input/Joystick_Y_${this.number}/`)
      this.connectSocket(this.xsocket, url + `/input/Joystick_X_${this.number}`)
      this.connectSocket(this.ysocket, url + `/input/Joystick_Y_${this.number}`)
    },
    connectSocket (sock, url) {
      sock.onopen = () => {
        this.$store.commit('socket/sendMessage', { message: 'ready', socket: sock })
      }
    },
    setControll () {
      if (this.on) this.initDraggable()
    },
    initDraggable () {
      window.Draggable.get(`#${this.data.id}`).disable()
      const outerjyst = document.querySelector(`#${this.data.id} #outer-jyst`)
      const xsocket = this.xsocket
      const ysocket = this.ysocket
      window.Draggable.create(`#${this.data.id} #inner-jyst`, {
        onDrag: function () {
          const x = this.x
          const y = -this.y
          let angle = (Math.atan(y / x) * 180) / Math.PI
          const radius = Math.sqrt(x * x + y * y)
          const dist = outerjyst.getBBox().width / 2 + 20
          if (radius > dist) {
            this.endDrag()
          }
          if (x === 0 && y > 0) {
            angle = 0
          } else if (x === 0 && y < 0) {
            angle = 180
          } else if (x > 0 && y === 0) {
            angle = 90
          } else if (x < 0 && y === 0) {
            angle = -90
          } else if (x > 0 && y > 0) {
            angle = 90 - angle
          } else if (x > 0 && y < 0) {
            angle = 90
          } else if (x < 0 && y < 0) {
            angle = -90 - angle
          } else if (x < 0 && y > 0) {
            angle = -90 + -angle
          }
          let rx = Math.round(x) / 100
          let ry = Math.round(y) / 100

          if (rx > 1) rx = 1.0
          else if (rx < -1) rx = -1.0
          if (ry > 1) ry = 1.0
          else if (ry < -1) ry = -1.0

          const mx = Math.round(map(rx, -1, 1, 0, 1023))
          const my = Math.round(map(ry, -1, 1, 0, 1023))
          const contents = `x : ${mx} , y : ${my}`
          store.commit('socket/sendMessage', { socket: xsocket, message: { value: mx } })
          store.commit('socket/sendMessage', { socket: ysocket, message: { value: my } })
        },
        onDragEnd: function () {
          window.gsap.to(this.target, {
            x: 0,
            y: 0,
            duration: 1,
            ease: 'elastic'
          })
          store.commit('socket/sendMessage', { socket: xsocket, message: { value: 512 } })
          store.commit('socket/sendMessage', { socket: ysocket, message: { value: 512 } })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover {
    display: block;
    stroke: none;
    fill: none;
}
.pin:hover {
    cursor: pointer;
    .pin-cover {
        stroke-width: 3px;
        stroke: black;
        fill: #ff6f61;
    }
}
.selected {
    & path.st1,
    & path.st8 {
        stroke: #ff6f61;
        stroke-width: 4px;
    }
}
.on{
  fill: #ff6f61;
}
.name {
    font-size: 26px;
}
.btn-key:hover{
  cursor: pointer;
}
.st0 {
    fill: #d6d6d6;
    display: none;
}
.st1 {
    fill: #3074a1;
}
.st2 {
    fill: #ffffff;
}
.st3 {
    font-family: "MyriadPro-Regular";
}
.st4 {
    font-size: 20px;
}
.st5 {
    fill: url(#SVGID_1_);
}
.st6 {
    fill: url(#SVGID_2_);
}
.st7 {
    fill: #333333;
}
.st8 {
    fill: #808080;
}
.st9{
 fill:#444;
 stroke: black;
}
</style>
